import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MfFormControlComponent } from '../mf-form-control.component';
import { Moment } from 'moment';
import *  as moment from 'moment';

@Component({
	selector: 'app-mfcustom-time-picker',
	templateUrl: './mfcustom-time-picker.component.html',
	styleUrls: ['./mfcustom-time-picker.component.css']
})
export class MFCustomTimePickerComponent implements OnInit {
	@Output() public dataChange = new EventEmitter();
	@Input() fieldDisabled: boolean;
	@Input() controlName: string;
	@Input() public set data(val) {
		this._data = val;
		if (val) {
			var date = moment(val);
			if (date.isValid()) {
				this._hour = (date.hour() < 10 ? "0" : "") + (date.hour());
				this._minute = (date.minute() < 10 ? "0" : "") + (date.minute());
			}
			else {
				if (val.indexOf(":") > 0) {
					var split = val.split(':');
					if (split.length >= 2) {
						date = moment.utc(`1900-01-01 ${split[0]}:${split[1]} +0000`, "YYYY-MM-DD HH:mm Z");
						if (date.isValid()) {
							this._hour = (date.hour() < 10 ? "0" : "") + (date.hour());
							this._minute = (date.minute() < 10 ? "0" : "") + (date.minute());
						}
						return;
					}
				}

				this._hour = null;
				this._minute = null;

			}
		}
		else {
			this._hour = null;
			this._minute = null;
		}
	};
	public hours: any = new Array();
	public minutes: any = new Array();
	private _hour: any;
	private _minute: any;
	public get hour() { return this._hour }
	public get minute() { return this._minute }
	public set hour(value) {
		
		if (value == "")
			value = null;
		this._hour = value;
		if (this.hour != null && typeof this.hour != 'undefined' && this.hour != '' &&
			(this._minute == null || typeof this._minute == 'undefined' || this._minute == '' || this.minute == NaN))
			this._minute = "00";
		//this._day = value;
		this.validateDate();
	}
	public set minute(value) {
		
		if (value == "")
			value = null;
		this._minute = value;
		//this._day = value;
		this.validateDate();
	}
	public get data() {
		return this._data;
	}
	@Input() parent: MfFormControlComponent;
	private _data: any;
	constructor() {
		for (var x = 0; x <= 23; x++) {
			this.hours.push({ label: (x < 10 ? "0" : "") + (x), value: (x < 10 ? "0" : "") + x });
		}
		for (var x = 0; x <= 59; x++) {
			this.minutes.push({ label: (x < 10 ? "0" : "") + (x), value: (x < 10 ? "0" : "") + x });
		}
	}

	validateDate() {
		if (this.hour != null && typeof this.hour != 'undefined' && this.hour != '' &&
			this.minute != null && typeof this.minute != 'undefined' && this.minute != ''
		) {
			try {
				//var date = moment(Date.UTC(1900, 0, 1, parseInt(this.hour), parseInt(this.minute), 0, 0));
				var date = moment.utc(`1900-01-01 ${this.hour}:${this.minute} +0000`, "YYYY-MM-DD HH:mm Z");
			} catch  {
				date = null;
			}
			this._data = date;
			this.dataChange.emit(this._data);
		}
	}

	ngOnInit() {
	}

	onKey(event: any, maxVal, maxchars, model) {
		if (event.target.value.length > maxchars) {
			if (event.target.value[0] == "0")
				event.target.value = event.target.value.substring(1, event.target.value.length)
			
		}
		if (event.target.value.length > maxchars) {
			if (event.target.value[event.target.value.length - 1] == "0")
				event.target.value = event.target.value.substring(0, event.target.value.length)
		}
		if (event.target.value > maxVal) {
			event.target.value = maxVal;
		}
		if (event.target.value != model) {
			this[model] = event.target.value;
		}
	}

}
